// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"869bd9a6","349":"477cb929","504":"b4b3924a","516":"7a50b68f","780":"052997c1","841":"23d5ea6f","870":"5c5e44f4"}[chunkId] + ".chunk.js";
};